import { computed } from "vue";
import { useRoute } from "vue-router";
import { useQuery } from "@tanstack/vue-query";
import { getByIdRepairsQuery } from "@vendata/power-up-sdk/requests/repairs/get-by-id";

export function useRepairDetailLoader() {
  const route = useRoute();
  const id = computed(() => String(route.params.id ?? ""));

  return {
    repairQuery: useQuery(getByIdRepairsQuery({ id })),
  };
}
